import { AuthorizationService } from "src/app/services/authorization.service";

export class ContractViewToolbarHelper {
    public showAction: string;
    public currentToolbar = [];
    private readonly TOOLBAR_ITEMS = [
      {
        feature: 'ContractManagement::AddEditContract',
        item: {
          label: 'Add Contract',
          name: 'addContract',
          tip: 'Add Contract',
          icon: '#inm-icon__plus-square',
          disabled: false,
          show: true,
        },
      },
    ];
    constructor(private authService: AuthorizationService) {
      this.generateToolbarData();
    }

    generateToolbarData(): void {
      for (const toolbar of this.TOOLBAR_ITEMS) {
        if (!toolbar.feature) {
          this.currentToolbar.push(toolbar.item);
          continue;
        }
        if (toolbar.feature && this.authService.hasFeature(toolbar.feature)) {
          this.currentToolbar.push(toolbar.item);
        }
      }
    }
}
